// closeModalByStateKey — close a stateKey-driven Modal from a Close
// override handler. Walks up from `modalEl` until it finds the nearest
// ancestor declaring `stateKey` (the Modal element itself or one of
// its wrappers), reads its `extraClose` block, and pushes
// `{ [stateKey]: null, ...extraClose }` onto `root` — the exact
// contract the canonical Modal close path uses
// (shared/components/Modal.js → backdrop/Escape handlers).
//
// Use this when the brand `ModalHeader.Icons.Close` default handler
// (`el.call('closeModal')`) doesn't apply for whatever reason and a
// per-modal override is needed: instead of hardcoding the literal
// stateKey + extraClose fields (which drift away from the Modal's own
// declaration as soon as it gains another extraClose entry), defer to
// the helper so the override stays in lockstep with the Modal's
// declaration.
//
// Why a function and not a method on `el`: it lets the helper run from
// any handler — `onClick: (e, el, s) => el.call('closeModalByStateKey',
// s.root, el)` — without requiring a `this`-bound invocation.
//
// Returns true on success, false on no-op (no stateKey ancestor or
// no root.update available).
export const closeModalByStateKey = (root, modalEl) => {
  if (!root || typeof root.update !== 'function') return false
  let m = modalEl
  while (m) {
    const sk = typeof m.stateKey === 'string' ? m.stateKey : null
    if (sk) {
      const extra =
        m.extraClose && typeof m.extraClose === 'object' && !Array.isArray(m.extraClose)
          ? m.extraClose
          : null
      root.update(extra ? { [sk]: null, ...extra } : { [sk]: null })
      return true
    }
    m = m.parent
  }
  return false
}
